import {
    OPERATOR_TYPES_1,
    OPERATOR_TYPES_2,
    OPERATOR_TYPES_3,
    OPERATOR_TYPES_6,
    OPERATOR_TYPES_7,
    OPERATOR_TYPES_10,
    OPERATOR_TYPES_11,
} from '../operators';

export const opportunityFilters = [
    {
        key: 'opportunity_pipeline_id',
        name: 'Funil da oportunidade',
        attributeI18nKey: 'OPPORTUNITY_PIPELINE_ID',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
    },
    {
        key: 'opportunity_status',
        name: 'Status da oportunidade',
        attributeI18nKey: 'OPPORTUNITY_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
    },
    {
        key: 'opportunity_stage_id',
        name: 'Etapa da oportunidade',
        attributeI18nKey: 'OPPORTUNITY_STAGE_ID',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
    },
    {
        key: 'opportunity_value',
        name: 'Valor da oportunidade',
        attributeI18nKey: 'OPPORTUNITY_VALUE',
        inputType: 'number',
        filterOperators: OPERATOR_TYPES_7,
    },
    {
        key: 'opportunity_currency',
        name: 'Moeda da oportunidade',
        attributeI18nKey: 'OPPORTUNITY_CURRENCY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
    },
    {
        key: 'opportunity_owner_id',
        name: 'Responsável pela oportunidade',
        attributeI18nKey: 'OPPORTUNITY_OWNER_ID',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
    },
    {
        key: 'opportunity_sla_status',
        name: 'Prazo da oportunidade',
        attributeI18nKey: 'OPPORTUNITY_SLA_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
    },
    {
        key: 'opportunity_temperature',
        name: 'Temperatura da oportunidade',
        attributeI18nKey: 'OPPORTUNITY_TEMPERATURE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
    },
];

export const opportunityActivityFilters = [
    {
        key: 'opportunity_activity_type',
        name: 'Tipo da atividade',
        attributeI18nKey: 'OPPORTUNITY_ACTIVITY_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
    },
];

export const commonFilters = [
    {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
    },
    {
        key: 'day_of_week',
        name: 'Day of week',
        attributeI18nKey: 'DAY_OF_WEEK',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_11,
    },
    {
        key: 'hour_of_day',
        name: 'Hour of day',
        attributeI18nKey: 'HOUR_OF_DAY',
        inputType: 'number',
        filterOperators: OPERATOR_TYPES_7,
    },
    {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
    },
    {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
    },
    {
        key: 'conversation_language',
        name: 'Conversation Language',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
    },
    {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
    },
    {
        key: 'template_name',
        name: 'Template Name',
        attributeI18nKey: 'TEMPLATE_NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
    },
    {
        key: 'labels',
        name: 'Labels',
        attributeI18nKey: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_10,
    },
    {
        key: 'browser_language',
        name: 'Browser Language',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
    },
    {
        key: 'priority',
        name: 'Priority',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_11,
    },
    {
        key: 'referer',
        name: 'Referrer Link',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
    },
    {
        key: 'country_code',
        name: 'Country',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
    },
    {
        key: 'last_closure_reason_id',
        name: 'Last closure reason',
        attributeI18nKey: 'LAST_CLOSURE_REASON',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_11,
    },
    {
        key: 'event_id',
        name: 'Evento',
        attributeI18nKey: 'EVENT_ID',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
    },
];

export const teamAgentFilters = [
    {
        key: 'assignee_id',
        name: 'Assignee',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
    },
    {
        key: 'team_id',
        name: 'Team',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
    },
];

export const commonFiltersAndTeamAgent = commonFilters.concat(teamAgentFilters);
